module.exports = __webpack_public_path__ + "fonts/天上一只小星星-fixed-repaired.1697a289.ttf";